import React, { Component } from 'react';
import { connect } from 'react-redux';
import VideoViewModal from '../../../../views/app/common/modal/VideoViewModal';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';

class ModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({ name: 'videoViewModal', value: false });
  };

  render() {
    return <VideoViewModal {...this.state} {...this.props} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.videoViewModal.isOpen,
    data: state.app.videoViewModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: appActions.appToggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(ModalContainer));
